import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { useAppDispatch } from "../../store/hooks";
import { loginRequest } from "../../auth/admin-auth/AdminAuthConfig";
import { adminAuthSliceActions } from "../../auth/admin-auth/AdminAuthSlice";
import useIdleTimeout from "./UseIdleTimeout";
import CustomSpinner from "../../components/custom-spinner/CustomSpinner";

const AdminAuthGuard: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { instance, accounts } = useMsal();
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(true);

  // Monitor idle timeout for 1 hour
  useIdleTimeout(3600000);

  useEffect(() => {
    const authenticateUser = async () => {
      if (accounts.length > 0) {
        const request = { ...loginRequest, account: accounts[0] };

        try {
          const response = await instance.acquireTokenSilent(request);

          // Extract user data
          const { accessToken, account } = response;
          const { name, username: email, localAccountId: userId } = account;

          // Dispatch user data to Redux store
          dispatch(
            adminAuthSliceActions.setUser({
              accessToken,
              name: name ?? null,
              email,
              userId,
            })
          );

          setIsLoading(false);
        } catch (error) {
          console.error("Token acquisition failed:", error);
          setIsLoading(false);
          instance.acquireTokenRedirect(request);
        }
      } else {
        console.warn("No account found. Redirecting to login.");
        instance.loginRedirect(loginRequest);
      }
    };

    authenticateUser();
  }, [instance, accounts, dispatch]);

  if (isLoading) {
    return <CustomSpinner />;
  }

  return <>{children}</>;
};

export default AdminAuthGuard;
